import classnames from 'classnames'
import { ComponentChild, FunctionalComponent, h } from 'preact'

export interface ListGroupProps {
  spacing?: string
  className?: string
  gutterBottom?: boolean
  children: ComponentChild[]
}

const ListGroup: FunctionalComponent<ListGroupProps> = (props) => {
  const { spacing = '4px', gutterBottom, children, className, ...restProps } = props
  const spacingClassPostfix = spacing.replace('px', '')
  return (
    <ul
      className={classnames(className, 'list-group', `list-group--spacing${spacingClassPostfix}`, {
        'list-group--gutter-bottom': gutterBottom
      })}
      {...restProps}
    >
      {/** Note:
       * Use childToArray or React.Children
       * when migrate to React or Preact X
       * */}
      {props.children.map((child, index) => (
        <li key={index}>{child}</li>
      ))}
    </ul>
  )
}

export default ListGroup
